import {
    scotlandRegex,
    walesRegex,
    walesTemplateId,
} from 'src/domains/sportsbook/state/eventsListState/EventsTemplates';
import { INTERNATIONAL_FLAG_CODE, flagContents } from 'src/ui/assets/icons/flags/flagContents';

const northernIrelandRegex = [/northern ireland/i, /\bnifl\b/i];
const englandRegex = [/\bengland\b/i];

const matchesAny = (name: string, patterns: Array<RegExp>): boolean => patterns.some((pattern) => pattern.test(name));

export const resolveCompetitionFlagCode = (competitionName: string | undefined, countryTag: string | null): string => {
    if (competitionName) {
        if (matchesAny(competitionName, scotlandRegex)) {
            return 'sco';
        }

        if (matchesAny(competitionName, walesRegex) || walesTemplateId.includes(competitionName)) {
            return 'wal';
        }

        if (matchesAny(competitionName, northernIrelandRegex)) {
            return 'nir';
        }

        if (matchesAny(competitionName, englandRegex)) {
            return 'eng';
        }
    }

    const tagCode = countryTag === null ? null : countryTag.toLowerCase();

    if (tagCode !== null && flagContents[tagCode] !== undefined) {
        return tagCode;
    }

    return INTERNATIONAL_FLAG_CODE;
};
